import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { TopSellingCategory } from "../../dashboard.types";
import { requestTopSellingCategories } from "./topSellingCategories.request";

const useTopSellingCategories = (
  options?: QueryOptions<TopSellingCategory[], ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["topSellingCategories"],
    queryFn: requestTopSellingCategories,
    ...options
  });

  return { categories: data, ...rest };
};

export default useTopSellingCategories;
